module.exports = __webpack_public_path__ + "img/mission.c49e3f0.jpg";